'use client';
import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import AnchorNav from '@/app/components/AnchorNav';
import { useLanguage } from '@/context/LanguageContext';
import { SUPPORTED_LANGUAGES } from '@/lib/i18n';

export default function SiteHeader() {
  const { language, setLanguage } = useLanguage();

  return (
    <header
      id="top"
      className="sticky top-0 z-50 w-full bg-card border-b border-border shadow-card"
    >
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center justify-between gap-4">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 flex-shrink-0 group">
          <AppLogo size={36} />
          <span className="font-extrabold text-lg tracking-tight text-foreground group-hover:text-primary transition-colors duration-150">
            BNBCalc
          </span>
        </a>

        {/* Anchor navigation */}
        <AnchorNav />

        {/* Right side: Language switcher + BNB badge */}
        <div className="flex items-center gap-2 flex-shrink-0">
          {/* Language switcher */}
          <div className="flex items-center rounded-md border border-border overflow-hidden">
            {SUPPORTED_LANGUAGES?.map((lang) => (
              <button
                key={lang?.code}
                onClick={() => setLanguage(lang?.code)}
                title={lang?.label}
                className={`flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold transition-all duration-150 ${
                  language === lang?.code
                    ? 'bg-primary text-white' :'bg-card text-muted-foreground hover:bg-primary/8 hover:text-primary'
                }`}
              >
                <span>{lang?.flag}</span>
                <span className="hidden sm:inline">{lang?.code?.toUpperCase()}</span>
              </button>
            ))}
          </div>

          {/* BNB badge */}
          <div className="hidden sm:flex items-center gap-1.5 bg-primary/8 border border-primary/20 rounded-md px-3 py-1.5">
            <span className="w-2 h-2 rounded-full bg-accent inline-block"></span>
            <span className="text-xs font-600 text-primary tracking-wide font-semibold">
              BNB Official Fixing
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}